"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Copyable = void 0;

var _react = require("react");

var _reactCopyToClipboard = _interopRequireDefault(require("react-copy-to-clipboard"));

var _ = require(".");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["text", "icon", "fill", "width", "children"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Copyable = function Copyable(_ref) {
  var text = _ref.text,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'copy' : _ref$icon,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#b5bfc7' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '12px' : _ref$width,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      copied = _useState2[0],
      setCopied = _useState2[1];

  (0, _react.useEffect)(function () {
    if (copied) {
      var timeout = setTimeout(function () {
        setCopied(false);
      }, 2000);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [copied]);

  var handleCopy = function handleCopy() {
    setCopied(true);
  };

  if (children) {
    return (0, _jsxRuntime.jsx)(_reactCopyToClipboard["default"], {
      text: text,
      onCopy: handleCopy,
      children: (0, _jsxRuntime.jsxs)(_.Flex, _objectSpread(_objectSpread({
        sx: {
          cursor: 'pointer'
        }
      }, props), {}, {
        children: [children, (0, _jsxRuntime.jsx)(_.Icon, {
          type: copied ? 'checkmark' : icon,
          fill: fill,
          width: width,
          ml: "1"
        })]
      }))
    });
  }

  return (0, _jsxRuntime.jsx)(_reactCopyToClipboard["default"], {
    text: text,
    onCopy: handleCopy,
    children: (0, _jsxRuntime.jsx)(_.Icon, {
      type: copied ? 'checkmark' : icon,
      fill: fill,
      width: width,
      sx: {
        cursor: 'pointer'
      }
    })
  });
};

exports.Copyable = Copyable;